import { motion } from "framer-motion";

export function LogoSvg({ inView }) {
  return (
    <>
      <motion.svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.0"
        viewBox="0 0 2065.000000 243.000000"
        preserveAspectRatio="xMidYMid meet"
        className="navbar__lgoSvg"
        id="navbar__lgoSvg"
      >
        <g
          id="g1"
          transform="translate(0.000000,243.000000) scale(0.100000,-0.100000)"
          fill={inView ? "#f2d729" : "#222"}
          stroke="none"
        >
          <path d="M241 2415 c-68 -19 -109 -44 -156 -96 -61 -67 -80 -121 -80 -219 0 -79 3 -90 36 -150 129 -235 464 -224 577 18 38 81 38 193 -1 274 -66 137 -232 213 -376 173z" />
          <path d="M1139 2417 c-99 -28 -198 -111 -242 -205 l-22 -47 0 -945 0 -945 33 -67 c40 -81 110 -148 190 -180 l57 -23 630 0 c512 0 639 3 679 14 63 19 156 87 196 147 60 86 60 84 60 691 l0 553 -495 0 -495 0 0 -250 0 -250 170 0 170 0 0 -150 0 -150 -275 0 -275 0 0 610 0 610 275 0 275 0 0 -110 0 -110 325 0 325 0 0 265 c0 243 -2 269 -21 320 -29 78 -111 164 -191 201 l-63 29 -630 2 c-478 2 -641 -1 -676 -10z" />
          <path d="M2940 1215 l0 -1215 833 2 832 3 0 300 0 300 -507 3 -508 2 0 150 0 150 465 0 465 0 0 300 0 300 -462 2 -463 3 -3 158 -3 157 511 0 510 0 0 300 0 300 -835 0 -835 0 0 -1215z" />
          <path d="M4830 1215 l0 -1215 833 2 832 3 0 300 0 300 -507 3 -508 2 0 150 0 150 465 0 465 0 0 300 0 300 -465 0 -465 0 0 160 0 160 510 0 510 0 -2 298 -3 297 -832 3 -833 2 0 -1215z" />
          <path d="M6720 1215 l0 -1215 323 2 322 3 5 240 5 240 78 112 c43 62 82 115 86 118 5 2 109 -151 231 -341 123 -190 229 -352 237 -360 12 -12 77 -14 379 -14 200 0 364 2 364 5 0 3 -182 291 -405 640 -223 348 -405 640 -405 647 0 8 173 266 385 574 l384 559 -346 3 c-269 2 -350 -1 -359 -10 -7 -7 -96 -130 -199 -273 -121 -169 -204 -295 -236 -360 -55 -110 -94 -252 -104 -377 l-7 -78 -44 0 -44 0 -2 548 -3 547 -322 3 -323 2 0 -1215z" />
          <path d="M9145 2421 c-92 -23 -199 -111 -242 -200 l-28 -56 -3 -353 c-3 -382 -1 -407 53 -492 28 -45 93 -104 142 -128 21 -11 250 -95 508 -187 259 -93 476 -173 483 -178 8 -6 12 -42 12 -113 l0 -104 -275 0 -274 0 -3 123 -3 122 -323 3 -323 2 3 -297 3 -298 30 -58 c37 -74 117 -148 193 -179 l57 -23 640 0 640 0 58 23 c71 29 153 107 193 182 l29 55 0 390 0 390 -26 56 c-36 75 -86 130 -156 167 -32 17 -265 105 -518 196 -253 90 -468 168 -477 171 -15 6 -18 21 -18 101 l0 94 275 0 274 0 3 -112 3 -113 320 0 320 0 0 275 0 275 -33 67 c-38 78 -100 138 -182 177 l-55 26 -635 2 c-349 1 -648 -2 -665 -6z" />
          <path d="M11153 2423 l-213 -3 0 -1210 0 -1210 345 0 345 0 0 725 c0 700 1 725 19 725 16 0 19 -11 25 -91 15 -200 61 -370 163 -602 50 -113 70 -148 87 -152 11 -3 147 -4 301 -3 l280 3 37 75 c118 242 182 461 203 698 5 52 11 72 21 72 12 0 14 -113 16 -722 l3 -723 343 -3 342 -2 0 1210 0 1210 -459 0 c-355 0 -461 -3 -469 -12 -19 -24 -194 -443 -227 -544 -42 -127 -73 -285 -81 -414 -6 -86 -9 -100 -24 -100 -15 0 -19 13 -24 78 -25 290 -56 393 -253 852 -48 111 -62 135 -83 141 -24 7 -270 7 -697 2z m775 -265 c163 -383 183 -457 210 -778 l7 -85 65 0 65 0 7 119 c14 243 56 397 201 736 l92 215 423 3 422 2 0 -1160 0 -1160 -290 0 -290 0 0 725 0 726 -67 -3 -68 -3 -7 -70 c-30 -290 -68 -433 -183 -681 l-44 -94 -266 2 -267 3 -54 124 c-101 226 -146 400 -162 611 l-7 105 -67 3 -68 3 0 -726 0 -725 -295 0 -295 0 0 1160 0 1160 424 0 424 0 90 -212z" />
          <path d="M16178 2423 l-588 -3 0 -1210 0 -1211 783 3 782 3 57 23 c81 33 160 108 200 190 l33 67 3 905 c2 884 2 907 -18 970 -36 117 -129 209 -246 247 -60 19 -192 21 -1006 16z m1037 -85 c66 -34 137 -111 161 -173 18 -48 19 -87 19 -960 l0 -910 -23 -46 c-36 -74 -87 -125 -160 -161 l-67 -33 -752 -3 -753 -3 0 1161 0 1160 763 -2 762 -3 50 -27z" />
          <path d="M16227 1833 c-4 -3 -7 -285 -7 -625 l0 -618 295 0 295 0 0 625 0 625 -288 0 c-159 0 -292 -3 -295 -7z m533 -623 l0 -570 -240 0 -240 0 0 570 0 570 240 0 240 0 0 -570z" />
          <path d="M13690 1210 l0 -1210 840 0 840 0 0 320 0 320 -495 0 -495 0 0 125 0 125 450 0 450 0 0 320 0 320 -450 0 -450 0 0 130 0 130 495 0 495 0 0 315 0 315 -840 0 -840 0 0 -1210z m1630 895 l0 -265 -497 -2 -498 -3 -3 -177 -2 -178 455 0 455 0 0 -270 0 -270 -455 0 -455 0 0 -175 0 -175 500 0 500 0 0 -270 0 -270 -790 0 -790 0 0 1160 0 1160 790 0 790 0 0 -265z" />
          <path d="M17660 1210 l0 -1210 345 0 345 0 0 1210 0 1210 -345 0 -345 0 0 -1210z m640 0 l0 -1160 -292 2 -293 3 -3 1158 -2 1157 295 0 295 0 0 -1160z" />
          <path d="M18782 1223 c-150 -659 -272 -1204 -272 -1210 0 -19 663 -19 678 0 6 7 25 78 42 158 17 79 33 152 36 162 5 16 29 17 312 17 l307 0 24 -107 c12 -60 30 -138 38 -175 l15 -68 345 0 345 0 -7 27 c-3 16 -126 559 -273 1208 l-268 1180 -525 3 -525 2 -272 -1197z m1539 2 c142 -627 259 -1148 259 -1157 0 -17 -20 -18 -288 -18 l-289 0 -38 175 -38 175 -342 0 c-271 0 -345 -3 -353 -13 -6 -7 -25 -78 -42 -158 -17 -79 -33 -152 -36 -161 -5 -17 -28 -18 -296 -18 l-290 0 5 23 c3 12 122 534 264 1160 l258 1137 484 -2 484 -3 258 -1140z" />
          <path d="M19506 1828 c-3 -7 -7 -65 -10 -129 -7 -137 -18 -198 -97 -543 -32 -142 -59 -260 -59 -262 0 -2 106 -4 235 -4 193 0 235 2 235 14 0 7 -27 128 -59 267 -71 302 -89 402 -97 529 -8 149 -4 140 -80 140 -43 0 -66 -4 -68 -12z m97 -140 c4 -51 13 -133 22 -183 13 -76 105 -482 121 -537 5 -17 -7 -18 -165 -18 -140 0 -171 3 -171 14 0 8 15 79 34 158 61 254 94 431 101 533 8 120 9 125 33 125 17 0 20 -11 25 -92z" />
          <path d="M0 780 l0 -780 323 2 322 3 3 778 2 777 -325 0 -325 0 0 -780z" />
        </g>
      </motion.svg>
      <div id="logo_div2">
        <svg
          className="nav__logoSvg2"
          id="nav__logoSvg2"
          width="162"
          height="73"
          viewBox="0 0 162 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="g2" fill={inView ? "#f2d729" : "#222"} stroke="none">
            <path d="M106.43 72.56H86.0498V0.680023H92.0398C98.8398 0.680023 105.65 0.680044 112.46 0.670044C113.28 0.670044 113.78 1.01002 114.1 1.77002C114.76 3.35002 115.44 4.93003 116.11 6.50003C117.34 9.38003 118.62 12.35 119.78 15.32C121.39 19.41 122.4 23.75 122.79 28.2C122.89 29.37 122.96 30.54 123.04 31.72L123.1 32.7H124.21C124.23 32.28 124.26 31.87 124.27 31.46C124.48 25.39 125.76 19.45 128.07 13.81C129.43 10.49 130.86 7.19002 132.28 3.90002L133.29 1.56003C133.46 1.15003 133.98 0.710022 134.52 0.710022C143.1 0.700022 151.68 0.700022 160.26 0.710022L160.57 0.76004L161.1 0.920044L161.19 1.50003V72.57H140.77V29.69H139.63C139.54 36.59 137.73 43.67 134.08 51.25C133.65 52.14 133.26 53.05 132.88 53.96C132.61 54.6 132.15 54.91 131.46 54.91H124.51C121.58 54.9 118.64 54.9 115.71 54.89C115.24 54.89 114.6 54.58 114.38 54.08C114.06 53.36 113.73 52.65 113.41 51.93C112.06 48.97 110.67 45.92 109.71 42.72C108.44 38.49 107.79 34.5 107.7 30.52C107.7 30.25 107.69 29.98 107.68 29.71H106.43V72.59V72.56ZM87.5498 71.06H104.93V28.18H108.96L109.1 28.76C109.14 28.92 109.17 29.02 109.17 29.16C109.19 29.59 109.2 30.03 109.21 30.47C109.29 34.31 109.93 38.17 111.16 42.27C112.09 45.37 113.46 48.38 114.79 51.29C115.1 51.97 115.41 52.65 115.71 53.33C118.68 53.38 121.6 53.38 124.52 53.38H131.47C131.89 52.43 132.3 51.5 132.73 50.58C136.35 43.07 138.11 36.07 138.13 29.19C138.13 28.98 138.2 28.81 138.23 28.72L138.42 28.24L138.96 28.16H142.27V71.04H159.68V2.18002C151.33 2.18002 142.98 2.18002 134.63 2.18002L133.65 4.46002C132.23 7.75002 130.81 11.04 129.45 14.35C127.21 19.82 125.97 25.58 125.76 31.48C125.74 31.93 125.72 32.38 125.69 32.83L125.62 34.17H121.68L121.53 31.78C121.46 30.61 121.39 29.45 121.29 28.29C120.92 23.99 119.94 19.79 118.38 15.84C117.22 12.89 115.95 9.93003 114.72 7.06003C114.04 5.48003 113.37 3.90004 112.71 2.32004C112.66 2.21004 112.63 2.17002 112.62 2.15002C112.62 2.15002 112.58 2.15002 112.45 2.15002C105.64 2.17002 98.8398 2.16003 92.0298 2.16003H87.5398V71.04L87.5498 71.06Z" />
            <path d="M61.1197 45.7H50.9897V30.98H80.4697C80.4897 31.37 80.5197 31.74 80.5197 32.11C80.5197 41.76 80.4897 51.41 80.5397 61.06C80.5597 65.48 78.7597 68.83 75.0497 71.17C73.6197 72.07 72.0497 72.59 70.3597 72.59C60.8797 72.62 51.3997 72.62 41.9197 72.62C39.8497 72.62 37.7797 72.65 35.7197 72.59C30.4697 72.45 25.9297 68.11 25.5097 62.86C25.4697 62.31 25.4497 61.76 25.4497 61.21C25.4497 44.8 25.4497 28.4 25.4497 11.99C25.4497 7.64002 27.1997 4.27004 30.9897 2.04004C32.6297 1.07004 34.4297 0.650024 36.3297 0.650024C47.4297 0.650024 58.5297 0.660024 69.6297 0.650024C75.3297 0.650024 80.5097 5.29002 80.5197 11.49C80.5197 15.83 80.5197 20.18 80.5197 24.52C80.5197 24.65 80.4797 24.78 80.4397 24.98H61.2297V18.56H44.8297V54.75H61.1297V45.7H61.1197Z" />
            <path d="M19.9395 72.6H0.769531V25.41H19.9395V72.6Z" />
            <path d="M10.3498 19.83C15.6462 19.83 19.9398 15.5364 19.9398 10.24C19.9398 4.94361 15.6462 0.650024 10.3498 0.650024C5.05335 0.650024 0.759766 4.94361 0.759766 10.24C0.759766 15.5364 5.05335 19.83 10.3498 19.83Z" />
          </g>
        </svg>
      </div>
    </>
  );
}

export function OpenSvg({ inView }) {
  return (
    <svg
      className="ham__svg1"
      id="ham__svg1"
      width="0"
      height="0"
      viewBox="0 0 71 71"
      fill="none"
      data-v-34966f4b=""
    >
      <rect
        id="ham__svg0"
        className="ham__svg0"
        x="0.80"
        y="0.80"
        width="0"
        height="0"
        rx="34.25"
        stroke={inView ? "#222" : "#f2d729"}
        strokeWidth="1.5"
        data-v-34966f4b=""
      ></rect>
      <rect
        className="ham__svg0"
        x="0.80"
        y="0.80"
        width="0"
        height="0"
        rx="34.25"
        stroke={inView ? "#222" : "#f2d729"}
        strokeWidth="1.5"
        data-v-34966f4b=""
      ></rect>
      <line
        x1="23.7949"
        y1="31.961"
        x2="52.9293"
        y2="31.961"
        stroke={inView ? "#222" : "#f2d729"}
        strokeWidth="2"
        className="open top"
        data-v-34966f4b=""
      ></line>
      <line
        x1="17.8281"
        y1="37.9152"
        x2="46.9625"
        y2="37.9152"
        stroke={inView ? "#222" : "#f2d729"}
        strokeWidth="2"
        className="open bottom"
        data-v-34966f4b=""
      ></line>
    </svg>
  );
}

export function CloseSvg({ inView }) {
  return (
    <svg
      className="ham__svg1"
      width="0"
      height="0"
      viewBox="0 0 71 71"
      fill="none"
      data-v-34966f4b=""
    >
      <rect
        className="ham__svg0"
        x="0.80"
        y="0.80"
        width="0"
        height="0"
        rx="34.25"
        stroke={inView ? "#f2d729" : "#222"}
        strokeWidth="1.5"
        data-v-34966f4b=""
      ></rect>
      <rect
        className="ham__svg0"
        x="0.80"
        y="0.80"
        width="0"
        height="0"
        rx="34.25"
        stroke={inView ? "#f2d729" : "#222"}
        strokeWidth="1.5"
        data-v-34966f4b=""
      ></rect>
      <line
        y1="-0.75"
        x2="29.1344"
        y2="-0.75"
        transform="matrix(-0.758907 -0.651199 -0.651199 0.758907 45.4375 44.9695)"
        stroke={inView ? "#f2d729" : "#222"}
        strokeWidth="2"
        className="close top"
        data-v-34966f4b=""
      ></line>
      <line
        x1="22.9491"
        y1="44.428"
        x2="45.0594"
        y2="25.4557"
        stroke={inView ? "#f2d729" : "#222"}
        strokeWidth="2"
        className="close bottom"
        data-v-34966f4b=""
      ></line>
    </svg>
  );
}
